import { Icon } from '@web/components/ui/icons'
import {
  ENTER_KEY_BEHAVIORS,
  enterKeyDescription,
  macKeyboard,
} from '@web/state/enter-key-behavior'
import { useIdentity } from '@web/state/identity'
import {
  saveLocalEnterKeyBehavior,
  useEnterKeyBehavior,
} from '@web/state/local-enter-key-behavior'
import { useState } from 'react'

/** One account preference shared by settings and every composer menu. */
export function EnterKeyBehaviorOptions({
  menu = false,
  onSelected,
}: {
  menu?: boolean
  onSelected?: () => void
}) {
  const identity = useIdentity()
  const [error, setError] = useState('')
  const current = useEnterKeyBehavior(
    identity.state?.current_user?.enter_key_behavior,
  )
  return (
    <>
      <div
        role={menu ? 'none' : 'radiogroup'}
        aria-label={menu ? undefined : 'Enter Key Behavior'}
        className="flex flex-col gap-1"
      >
        {ENTER_KEY_BEHAVIORS.map((option) => (
          <button
            type="button"
            key={option.value}
            role={menu ? 'menuitemradio' : 'radio'}
            aria-checked={current === option.value}
            disabled={identity.busy}
            className={`pill-menu-option flex w-full items-start gap-2 rounded-control px-3 py-2 text-left disabled:opacity-60 ${current === option.value ? 'bg-accent-soft' : ''}`}
            onClick={async () => {
              setError('')
              try {
                if (identity.state?.current_user)
                  await identity.savePreferences({
                    enter_key_behavior: option.value,
                  })
                saveLocalEnterKeyBehavior(option.value)
                onSelected?.()
              } catch (failure) {
                setError((failure as Error).message)
              }
            }}
          >
            <span className="min-w-0 flex-1">
              <span className="block text-[12.5px] font-medium">
                {option.label}
              </span>
              {enterKeyDescription(option.value, macKeyboard()).map((line) => (
                <span
                  key={line}
                  className="block text-[11px] leading-snug text-muted"
                >
                  {line}
                </span>
              ))}
            </span>
            <span className="mt-1 w-3 shrink-0 text-accent">
              {current === option.value && <Icon name="check" size={12} />}
            </span>
          </button>
        ))}
      </div>
      {error && (
        <p role="alert" className="px-3 py-2 text-xs text-danger">
          {error}
        </p>
      )}
    </>
  )
}
